// src/auth/canBuyPlans.js — "may this user open the plans screen and buy?" (v203).
//
// The plans screen (/billing, billing/*) answers only a company admin, or a superadmin outside admin mode
// (BE is_customer_admin_for). ⚠️ `isCustomerAdmin` is COARSE — "admin of ANY company": an admin of company A whose
// active workspace belongs to B passes here and then meets the screen's «riservata» panel. Accepted (rare); the
// exact answer needs a /credits/balance read (useManagedCompany().activeCompanyId).
// Used by the avatar menu (greyed «Piani») and by refusal CTAs (no /billing link for someone who cannot buy).
import { useContext } from 'react';
import { AuthContext } from './authContextObject.js';

export function canBuyPlans(auth) {
  if (!auth) return false;
  return !!auth.isCustomerAdmin || (!!auth.isSuperadmin && !auth.adminMode);
}

/** Null-safe: outside the AuthProvider (isolated component tests) the answer is false — no link offered. */
export function useCanBuyPlans() {
  return canBuyPlans(useContext(AuthContext));
}
